import Associates from './AssociatesPage';

export default Associates;
